'use client';

import type { AgentExecutionDto } from '@terra/shared-contracts-agent-execution';
import { Badge } from '@terra/ui-design-system';
import { token } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';

type AiDiscoveryStatusBadgeProps = {
  status:
    | AgentExecutionDto['status']
    | 'COMPLETED'
    | 'PENDING'
    | 'ACCESS_DENIED';
};

const STATUS_STYLE: Record<string, { bg: string }> = {
  PENDING: { bg: token('colors.bg.status.inProgress') },
  RUNNING: { bg: token('colors.bg.status.inProgress') },
  COMPLETED: { bg: token('colors.bg.status.resolved') },
  FAILED: { bg: token('colors.bg.neutral.error') },
  BLOCKED: { bg: token('colors.bg.neutral.error') },
  ABORTED: { bg: token('colors.bg.neutral.muted') },
  ACCESS_DENIED: { bg: token('colors.bg.neutral.error') },
};

export function AiDiscoveryStatusBadge({
  status,
}: AiDiscoveryStatusBadgeProps) {
  const t = useTranslations('discovery.aiApplication.status');
  const style = STATUS_STYLE[status] ?? STATUS_STYLE.ABORTED;

  return (
    <Badge size="sm" variant="fill" bg={style.bg}>
      {t(status)}
    </Badge>
  );
}
